module.exports = __webpack_public_path__ + "img/hj3.31293d47.jpg";